import { ChatMessageDirectiveController } from './chat-message.controller'

function chatMessageDirective () {
  return {
    restrict: 'E',
    scope: {
      message: '=',
      darkMode: '<',
      showSeeAttachment: '<',
      task: '<',
      isHover: '<?',
      onHover: '<',
      onBlur: '<',
      onEdit: '<',
      onDelete: '<',
      onPinTimeClick: '<',
      onPinnedChanges: '<'
    },
    templateUrl: '/core/directives/chat-message/chat-message.html?$$REVISION$$',
    controller: ChatMessageDirectiveController
  }
}
export { chatMessageDirective }
